import Tabs, { TabPane } from 'rc-tabs';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import { DepositHeader } from '..';
import { useState, useEffect } from 'react';
import Modal from './Modal';

SwiperCore.use([Pagination, Navigation])


const invoiceData = [
    {
        step: 'ขั้นตอนที่ 1',
        content: <p className='contentWithTitle' data-CN="選擇虛擬幣存款方式並輸入存款金額">
            เพิ่มหรือผูกบัญชีธนาคารสำหรับการฝากเงินด่วน โปรดตรวจสอบให้แน่ใจว่าโอนเงินจากบัญชีที่ผูกไว้
            เท่านั้น ป้องกันยอดเงินสูญหาย
        </p>,
        stepCN: '步骤1',
    },
    {
        step: 'ขั้นตอนที่ 2',
        content: <p className='contentWithTitle' data-CN="点击“确认”，进入支付页面。">
            คัดลอกเลขบัญชีของเราและทำการฝากเงินได้เลย ไม่ต้องแนบสลิปหรือกรอกฟอร์ม เพียงทำการฝาก
            เข้าบัญชีที่แสดงในระบบ
        </p>,
        stepCN: '步骤2',
    },
    {
        step: 'ขั้นตอนที่ 3',
        content: <p className='contentWithTitle' data-CN="複製錢包地址或使用電子錢包掃碼">
            ระบบจะปรับเงินอัตโนมัติภายใน 5 นาที กรุณาติดต่อฝ่ายบริการลูกค้าหากยอดเงินไม่ปรับ
            ภายในเวลาที่กำหนด
        </p>,
        stepCN: '步骤3',
    },
    {
        step: 'ขั้นตอนที่ 4',
        content: <p className='contentWithTitle' data-CN="您的交易被确认后。 余额将转入您的游戏钱包。 在“交易记录”中查看交易记录">
            โปรดตรวจสอบข้อมูลบัญชีธนาคารล่าสุดของเราก่อนการฝากเงิน และฝากเงินจากบัญชีที่ผูกเท่านั้น
            เพื่อการปรับเงินที่รวดเร็ว
        </p>,
        stepCN: '步骤4',
    },
]

function RDTutorialModal(props) {
    const { visible, onClose } = props;
    const [ isBeginning, setIsBeginning ] = useState(true);
    const [ isEnd, setIsEnd ] = useState(false);
    const closedModal = () => {
        onClose();
        setIsBeginning(true);
        setIsEnd(false);
    };
    return (
        <Modal
            className='tutorialModal RD-tutorialModal'
            visible={visible}
            fullscreen={false}
            title={<DepositHeader title={'ขั้นตอนการฝากเงิน'} closeBtn={closedModal} visibleBtn={false} />}
            onOk={closedModal}
            onlyOkBtn={true}
            okText={"ปิด"}
        >
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                className={`${isBeginning ? "hide-prev" : ""}${isEnd ? "hide-next" : ""}`}
                onSlideChange={(e) => {
                    setIsBeginning(e.isBeginning);
                    setIsEnd(e.isEnd);
                }}
            >
                {invoiceData.map((item, index) => {
                    return (
                        <SwiperSlide key={index + 'step'}>
                            <div className="tutorialCard">
                                <div className={`tutorial_img tutorialPic_RD_${index + 1}`} />
                                {item?.step && <h3 data-CN={item.stepCN}>{item.step}</h3>}
                                {item.content}
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </Modal>
    )
}

export default RDTutorialModal
